import { render, staticRenderFns } from "./Evaluation-questions.vue?vue&type=template&id=08862f72&scoped=true"
import script from "./Evaluation-questions.vue?vue&type=script&lang=js"
export * from "./Evaluation-questions.vue?vue&type=script&lang=js"
import style0 from "./Evaluation-questions.vue?vue&type=style&index=0&id=08862f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08862f72",
  null
  
)

export default component.exports